import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/no_items.png")